import { createReducer, on } from '@ngrx/store';
import { initialCompanyState } from '../states/company.state';
import * as CompanyActions from '../actions/company.action';

export const companyReducer = createReducer(
    initialCompanyState,
    on(CompanyActions.changed, (state, changes) => ({
        ...state,
        ...changes
    }))
);
